import { UUID } from 'src/util/types'

export enum PresentationAssetStatus {
  UPLOADING = 'Uploading',
  COMPLETED = 'Completed',
  ERROR = 'Error'
}

export enum PresentationAssetScrollmotionStatus {
  LEGACY = 'LEGACY',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE'
}

export type PresentationAsset = {
  url: string
  id: UUID
  path: string
  download: string
  size: number
  contentType: string
  md5: string
  createdAt: string
  createdBy?: string
  updatedAt: string
  updatedBy?: string
  status: PresentationAssetStatus
  error?: string
  isSm: boolean
  isSmComplete: boolean
  smStatus?: PresentationAssetScrollmotionStatus
  downloadCF: string
  downloadCFTTL: number
}
